'use strict';
module.exports = x => Object.is(x, -0);
